export enum MaritalStatusEnum {
  single = 'Solteiro (a)',
  married = 'Casado (a)',
  widower = 'Viúvo (a)',
  divorced = 'Divorciado (a)'
}
